<template>
  <groceries-view
    :groceries="groceries"
    :unit-system="settingStore.unitSystem"
    @add="add"
    @update="update"
    @remove="remove"
    @clear="clear"
  />
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { storeToRefs } from 'pinia';
  import { useFirestore } from 'vuefire';
  import { useAuthStore } from '@/stores/auth';
  import { useGroceryStore } from '@/stores/groceries';
  import { useSettingStore } from '@/stores/settings';
  import GroceryClient from '@/service/groceries/groceryClient';
  import { migrateLocalGroceries } from '@/service/groceries/migrateLocalGroceries';
  import GroceriesView from '@/views/groceries/GroceriesView.vue';

  export default defineComponent({
    name: 'GroceriesViewRoute',
    components: { GroceriesView },
    async setup() {
      const authStore = useAuthStore();
      const client = await GroceryClient.setup(
        useFirestore(),
        authStore.getIdentifier(),
      );
      await migrateLocalGroceries(client, localStorage);

      const store = useGroceryStore(client);
      const { groceries } = storeToRefs(store);

      return {
        groceries,
        settingStore: useSettingStore(),
        add: () => store.add(),
        update: store.update,
        remove: store.remove,
        clear: store.clear,
      };
    },
  });
</script>
